import React, { Component } from 'react';

export default class Input extends Component {
  render() {
    const { title, type = 'text', value, onChange, placeholder = '', className = '', pattern, inputMode, required, maxLength, min, max, disabled } = this.props;
    return (
      <div className={`flex flex-1 flex-col ${className}`}>
        <span className='text-sm font-normal text-[#21272A] my-2'>{title}</span>
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
          className={`placeholder-[#697077] focus:outline-none bg-[#F2F4F8] border-b border-[#C1C7CD] p-4 ` + className}
          pattern={pattern}
          inputMode={inputMode}
          required={required}
          min={min || 0}
          max={max || 9999999999}
          disabled={disabled}
        />
      </div>
    );
  }
}
